import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
  const router = inject(Router);
  const isLoggedIn = localStorage.getItem("isloggedin");
  const userModules = JSON.parse(localStorage.getItem("moduleSubmoduleDetails") || '[]'); // Ensure valid JSON
  const redirectTo = localStorage.getItem('defaultRoute')
  if (isLoggedIn !== 'true') {
    router.navigate(['login']);
    return false;
  }

  // Extract requested route path
  const requestedPath = state.url;

  // Check if user has `readAccess` for the requested route
  const hasAccess = userModules.some((module: any) => {
    if (module.moduleEndpoint === requestedPath && module.readAccess) {
      return true;
    }

    // Check in subModules
    return module.subModules?.some((sub: any) => sub.subModuleEndpoint === requestedPath && sub.readAccess);
  });

  if (!hasAccess) {
    router.navigate([redirectTo]); // Redirect to an default route if access is denied
    return false;
  }

  return true;
};
